import { render, staticRenderFns } from "./pageElementFiles.vue?vue&type=template&id=59db9e4a&scoped=true&"
import script from "./pageElementFiles.vue?vue&type=script&lang=js&"
export * from "./pageElementFiles.vue?vue&type=script&lang=js&"
import style0 from "./pageElementFiles.vue?vue&type=style&index=0&id=59db9e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db9e4a",
  null
  
)

export default component.exports